const initTealium = (isHybrid: boolean): void => {
  isHybrid && localStorage.setItem('isHybridFlow', isHybrid.toString());
  try {
    window.getTealiumScript?.();
  } catch (error) {
    console.error('Error calling getTealiumScript:', error);
  }
};

export { initTealium };
